// import DataObjectBaseClass from './Core';
function SAMAVictimStatus(aId) {
    "use strict";
    this.__type = 'SAMAVictimStatus:www.veritracks.com';
    this.Id = aId?aId:-1;
    this.HasVictimMobileApp = 0;
    this.CellPhoneNumber = '';
    this.AppUserId = gUserDetails.UserId?gUserDetails.UserId:0;
    this.SAMAFlag = 0;
}
SAMAVictimStatus.prototype = new DataObjectBaseClass();
SAMAVictimStatus.prototype.constructor = SAMAVictimStatus;

if (typeof exports !== 'undefined') {
    module.exports = SAMAVictimStatus;
}